import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaMailPecSummaryComponent } from './conservazione-carica-mail-pec-summary';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-mail-pec-summary', {
            url: '/conservazione-carica-mail-pec-summary',
            ncyBreadcrumb: {
                label: 'Carica Documento',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-mail-pec-summary flex="100"></conservazione-carica-mail-pec-summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaMailPecSummaryModule: string = ng
    .module('conservazione-carica-mail-pec-summary', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaMailPecSummary', ConservazioneCaricaMailPecSummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-mail-pec-summary/conservazione-carica-mail-pec-summary.module.ts